import { useWSQuery } from "../../query/helpers";

type Query = ReturnType<typeof useWSQuery>;
export const useIsQueriesFetched = <TQueries extends [Query, ...Query[]]>(
  ...queries: TQueries
) => {
  return queries.every(query => query.isFetched);
};
